import { render, staticRenderFns } from "./ProductImages.vue?vue&type=template&id=01d1c058&scoped=true"
import script from "./ProductImages.vue?vue&type=script&lang=js"
export * from "./ProductImages.vue?vue&type=script&lang=js"
import style0 from "./ProductImages.vue?vue&type=style&index=0&id=01d1c058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d1c058",
  null
  
)

export default component.exports